/**
 * Fetch interceptor — 401, 402 ve 403 HTTP yanıtlarını global olarak yakalar.
 *
 * fetch() tabanlı API çağrılarında (subscription-requests, account-requests vb.)
 * axios interceptor devreye girmez. Bu yüzden native fetch'i sarmalıyoruz.
 */
import store from "../store"
import { setPaymentRequired } from "../store/subscription/actions"

const originalFetch = window.fetch

window.fetch = async (...args) => {
  const res = await originalFetch(...args)

  // 401 — oturum süresi dolmuş
  if (res.status === 401) {
    const url = typeof args[0] === "string" ? args[0] : args[0]?.url || ""
    if (!url.includes("/api/auth/")) {
      localStorage.removeItem("authUser")
      localStorage.removeItem("tokenExp")
      window.location.href = "/login"
    }
  }

  // 402 — paket limiti aşıldı veya abonelik yok
  if (res.status === 402) {
    try {
      const cloned = res.clone()
      const data = await cloned.json()
      store.dispatch(setPaymentRequired({
        title: data?.message || "Paket Yükseltme Gerekli",
        message: data?.data?.detail || "Bu işlemi gerçekleştirebilmek için paketinizi yükseltmeniz gerekmektedir.",
      }))
    } catch {
      store.dispatch(setPaymentRequired({
        title: "Paket Yükseltme Gerekli",
        message: "Bu işlemi gerçekleştirebilmek için paketinizi yükseltmeniz gerekmektedir.",
      }))
    }
  }

  // 403 + featureCode — paket özelliği eksik. axios tarafındaki karşılığı
  // ContractInterceptor'da; ikisi de AYNI olayı yayınlar, pencereyi tek örnek
  // PlanFeatureProvider açar. Bu dal olmadan fetch ile yazılmış çağrılarda
  // (ticket-, company-, account-, payment-requests) kullanıcı deneme/yükseltme
  // penceresini hiç görmüyor, yalnız ham hata mesajı kalıyordu.
  if (res.status === 403) {
    try {
      const cloned = res.clone()
      const data = await cloned.json()
      const featureCode = data?.data?.featureCode
      if (featureCode) {
        window.dispatchEvent(new CustomEvent("plan-feature-denied", {
          detail: { featureCode, featureLabel: data?.data?.featureLabel },
        }))
      }
    } catch {
      // Gövdesi JSON olmayan 403'ler (ör. yetki reddi) buraya düşer; paket
      // kısıtı değildir, sessizce geçilir.
    }
  }

  return res
}
